export default "__VITE_ASSET__CAg108TI__"